import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../utils/helpers/model.helper';

export const ACCOUNT_SCHEMA = Object.freeze({
  ACCOUNT_ID: '',
  CREATED_DATE: '', // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  LAST_UPDATED: '', // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  DATA_CENTER_ID: '',
  OWNER_USER_ID: 0,
  OWNER_EMAIL: '',
  CREATOR_USER_ID: 0,
  CREATOR_EMAIL: '',
  VERSION: 0,
  STATUS: '',
  COMPANY_NAME: '',
  COMPANY_COUNTRY: '',
  EMAIL: '',
  PLATFORM_CREATED_ON: '',
});
const RECORD = generateSchema(ACCOUNT_SCHEMA);
const KEYS: any = generateKeys(ACCOUNT_SCHEMA);

export class Account extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get accountId(): string {
    return this.get(KEYS.ACCOUNT_ID);
  }

  get createDate(): string {
    return this.get(KEYS.CREATED_DATE);
  }

  get lastUpdated(): string {
    return this.get(KEYS.LAST_UPDATED);
  }

  get dataCenterId(): string {
    return this.get(KEYS.DATA_CENTER_ID);
  }

  get ownerUserId(): number {
    return this.get(KEYS.OWNER_USER_ID);
  }

  get ownerEmail(): string {
    return this.get(KEYS.OWNER_EMAIL);
  }

  get creatorUserId(): number {
    return this.get(KEYS.CREATOR_USER_ID);
  }

  get creatorEmail(): string {
    return this.get(KEYS.CREATOR_EMAIL);
  }

  get version(): number {
    return this.get(KEYS.VERSION);
  }

  get status(): string {
    return this.get(KEYS.STATUS);
  }

  get companyName(): string {
    return this.get(KEYS.COMPANY_NAME);
  }

  get companyCountry(): string {
    return this.get(KEYS.COMPANY_COUNTRY);
  }

  get email(): string {
    return this.get(KEYS.EMAIL);
  }

  get platformCreatedOn(): string {
    return this.get(KEYS.PLATFORM_CREATED_ON);
  }
}
